<template>
  <div>
    <p class="txt-center fonsize-16 txt-tranf">
      <b>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM </b>
    </p>
    <p class="txt-center fonsize-16">
      <b>Độc lập – Tự do – Hạnh phúc</b>
    </p>
    <p class="txt-center fonsize-16">***</p>
    <p class="txt-tranf txt-center fonsize-20">
      <b
        >PHỤ LỤC <br />
        <span class="text-uppercase">{{ title }}</span>
      </b>
    </p>
    <p class="txt-center">
      (Số: <mark>{{ dataAppendix ? dataAppendix.code : '' }}</mark
      >)
    </p>
    <h3>Căn cứ:</h3>
    <ul class="form-style">
      <li>
        Hợp đồng Cung Cấp Giải Pháp Chuyển Đổi Số Next360 số <mark>{{ dataContract.code }}</mark>
        ký ngày
        <span v-if="dataContract.effectiveFromDTO">
          <mark>{{ dataContract.effectiveFromDTO | formatDate('DD') }}</mark> tháng
          <mark>{{ dataContract.effectiveFromDTO | formatDate('MM') }}</mark> năm
          <mark>{{ dataContract.effectiveFromDTO | formatDate('YYYY') }}</mark> (“Hợp đồng”);
        </span>
        <span v-else-if="dataContract.dateEffectiveFrom">
          <mark>{{ dataContract.dateEffectiveFrom | formatDate('DD') }}</mark> tháng
          <mark>{{ dataContract.dateEffectiveFrom | formatDate('MM') }}</mark> năm
          <mark>{{ dataContract.dateEffectiveFrom | formatDate('YYYY') }}</mark> (“Hợp đồng”);
        </span>
        <span v-else-if="dataContract.dateSign">
          <mark>{{ dataContract.dateSign | formatDate('DD') }}</mark> tháng
          <mark>{{ dataContract.dateSign | formatDate('MM') }}</mark> năm
          <mark>{{ dataContract.dateSign | formatDate('YYYY') }}</mark> (“Hợp đồng”);
        </span>
      </li>
      <li>Nhu cầu và khả năng của hai Bên.</li>
    </ul>
    <p>
      Hôm nay, ngày
      <span v-if="dataAppendix.dateSignAppendixDTO">
        <mark>{{ dataAppendix.dateSignAppendixDTO | formatDate('DD') }}</mark>
        tháng <mark>{{ dataAppendix.dateSignAppendixDTO | formatDate('MM') }}</mark> năm
        <mark>{{ dataAppendix.dateSignAppendixDTO | formatDate('YYYY') }}</mark>
      </span>
      <span v-else-if="dataAppendix.dateCreatedAppendixDTO">
        <mark>{{ dataAppendix.dateCreatedAppendixDTO | formatDate('DD') }}</mark>
        tháng <mark>{{ dataAppendix.dateCreatedAppendixDTO | formatDate('MM') }}</mark> năm
        <mark>{{ dataAppendix.dateCreatedAppendixDTO | formatDate('YYYY') }}</mark>
      </span>
      <span v-else-if="dataContract.effectiveFromDTO">
        <mark>{{ dataContract.effectiveFromDTO | formatDate('DD') }}</mark> tháng
        <mark>{{ dataContract.effectiveFromDTO | formatDate('MM') }}</mark> năm
        <mark>{{ dataContract.effectiveFromDTO | formatDate('YYYY') }}</mark
        >,
      </span>
      <span v-else>
        <mark>{{ dataContract.dateEffectiveFrom | formatDate('DD') }}</mark> tháng
        <mark>{{ dataContract.dateEffectiveFrom | formatDate('MM') }}</mark> năm
        <mark>{{ dataContract.dateEffectiveFrom | formatDate('YYYY') }}</mark
        >,
      </span>
      tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:
    </p>
    <p class="fonsize-16 txt-tranf">
      <b v-if="!checkCreatedDateNganluong(dataAppendix)">BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b>
      <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
    </p>
    <p>và</p>
    <p class="fonsize-16 txt-tranf flex">
      <span> <b>BÊN B:</b></span>
      <mark>
        <b>
          {{ customerInfo ? customerInfo.merchantName : '' }}
        </b>
      </mark>
    </p>
    <p>&nbsp;</p>
    <p>
      Sau khi xem xét các điều khoản và điều kiện của Hợp Đồng, Các Bên cùng đồng ý ký kết và thực
      hiện Phụ lục của Hợp đồng các điều khoản dưới đây:
    </p>
  </div>
</template>

<script>
  export default {
    props: ['dataContract', 'dataAppendix', 'title', 'customerInfo'],
  }
</script>

<style scoped src="@/pages/contract/review/css/style-review.css"></style>
